import { Card } from '@chakra-ui/react'
import type { FC } from 'react'

import type { Playbook as GqlPlaybook } from '@graphql/types'

type Playbook = Pick<GqlPlaybook, 'id' | 'name' | 'shortDescription'>

interface Props {
  playbook: Playbook
  selectedPlaybook: Playbook | null
  setSelectedPlaybook: (playbook: Playbook | null) => void
}

const AiPlaybooksModalCard: FC<Props> = ({ playbook, selectedPlaybook, setSelectedPlaybook }) => {
  const isSelected = selectedPlaybook?.id === playbook.id
  const selectedProps = isSelected ? { borderColor: 'purple.500' } : {}

  return (
    <Card.Root
      {...selectedProps}
      transition="all 0.3s ease-in-out"
      key={playbook.id}
      cursor="pointer"
      onClick={() => setSelectedPlaybook(playbook)}
    >
      <Card.Body gap={2}>
        <Card.Title>{playbook.name}</Card.Title>
        <Card.Description>{playbook.shortDescription}</Card.Description>
      </Card.Body>
    </Card.Root>
  )
}

export default AiPlaybooksModalCard
